// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionHeader_wrapper___EcLG","titleWrapper":"SectionHeader_titleWrapper__Q4SLa","title":"SectionHeader_title__gu_Jw"};